import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../firebase";
import { GroupData } from "../../types/GroupData";
import ScoreBarChart from "../../components/user/ScoreBarChart";
import PortalEntry from "../../components/user/PortalEntry";
import { ChartNoAxesCombined, FileText, MicVocal } from "lucide-react";

const PortalGroupProfile = () => {
  const { groupName } = useParams();
  const [targetGroups, setTargetGroups] = useState<GroupData[]>([]);
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeTab, setActiveTab] = useState<"entry" | "chart" | "info">(
    "entry",
  );

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (!groupName) {
      setTargetGroups([]);
      return;
    }

    const fetchGroupsByName = async () => {
      // groups全件ではなく、この団体名に一致するものだけをFirestore側で絞り込む
      const groupsQuery = query(
        collection(db, "groups"),
        where("groupName", "==", groupName),
      );

      const snapshot = await getDocs(groupsQuery);
      const fetched: GroupData[] = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...(doc.data() as Omit<GroupData, "id">),
      }));

      const sorted = fetched.sort((a, b) => {
        const aYear = a.createdAt?.toDate().getFullYear() ?? 0;
        const bYear = b.createdAt?.toDate().getFullYear() ?? 0;

        return aYear - bYear;
      });

      setTargetGroups(sorted);
    };

    fetchGroupsByName();
  }, [groupName]);

  return (
    <div className="portal">
      <div className={`top ${isScrolled ? 'scrolled' : ''}`}>
        <h1>{groupName}</h1>
      </div>

      <div
        className="main-contents"
        style={{
          paddingBottom: "80px",
        }}
      >
        {activeTab === "entry" && (
          <>
            <h2>ENTRY</h2>
            <PortalEntry />
          </>
        )}

        {activeTab === "chart" && (
          <>
            <h2>GRAPH</h2>
            <ScoreBarChart groups={targetGroups} />
          </>
        )}

        {activeTab === "info" && (
          <>
            <h2>INFO</h2>
          </>
        )}
      </div>
      <div className="bottom-tab">
        <button
          className={activeTab === "entry" ? "active" : ""}
          onClick={() => setActiveTab("entry")}
        >
          <p>ENTRY</p>
          <MicVocal />
        </button>
        <button
          className={activeTab === "chart" ? "active" : ""}
          onClick={() => setActiveTab("chart")}
        >
          <p>GRAPH</p>
          <ChartNoAxesCombined />
        </button>
        <button
          className={activeTab === "info" ? "active" : ""}
          onClick={() => setActiveTab("info")}
        >
          <p>INFO</p>
          <FileText />
        </button>
      </div>
    </div>
  );
};

export default PortalGroupProfile;
